<template>
  <div class="search has-background-white-bis fixspace">

    <section class="hero is-small has-background-white-ter is-bold">
      <div class="hero-body">
        <div class="container has-text-centered py-6"></div>
      </div>
    </section>

    <section class="section">
      <div class="container is-max-desktop" style="margin-top: -100px;">
        <div class="columns">
          <div class="column is-three-fifths is-offset-one-fifth">
            <div class="box">
              <b-field>
                  <b-input
                    lazy
                    custom-class="is-white is-shadowless"
                    icon-pack="fas"
                    icon="search"
                    type="search"
                    inputmode="search"
                    :placeholder="$t('search.place')"
                    ref="inputSearch"
                    v-model="keyWord"
                    @input="onSearch"
                    icon-clickable
                    expanded
                  >
                  </b-input>
                  <!-- <p class="control">
                      <b-button type="is-primary" label="Search" />
                  </p> -->
              </b-field>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section pt-1">
      <div class="container has-text-centered">
        <h1 class="title" style="font-weight: 900;">
          {{ $t('search.searchmusian') }}
        </h1>
        <div class="py-1">
          <span class="subtitle has-text-grey-dark">
            {{ $t('search.suggested') }}
          </span>
          <span class="subtitle px-2 has-text-dark"
                v-for="keyWord in hotKeyWords" :key="keyWord"
                v-on:click="onClickKeyWord(keyWord)">
            #{{ keyWord }}
          </span>
        </div>
      </div>
      <div class="divider div-transparent my-6"></div>

      <div class="container">
        <div class="columns is-multiline">
          <div class="column is-one-third" v-for="item in list" :key="item.id">
            <div class="">
              <router-link :to='"/video/" + item.id'>
                <video-item
                  :channel-title="item.channel"
                  :youtube-id="item.provider_video_id"
                  :title="item._highlightResult.title.value" >
                </video-item>
              </router-link>
            </div>
          </div>
        </div>
      </div>

      <!-- No result section -->
      <div class="container has-text-centered" v-if="isResultEmpty">
        <div class="columns">
          <div class="column is-three-fifths is-offset-one-fifth">
            <div class="">
              <img src="/assets/empty.png" :alt="$t('search.noresult')">
            </div>
            <h1 class="title is-size-3-dsktop is-size-4-mobile has-text-weight-bold mt-5">
              {{ $t('search.noresult') }}
            </h1>
            <h2 class="is-size-6-desktop is-size-7-mobile has-text-weight-semibold pb-5">
              {{ $t('search.noresultmsg') }}
            </h2>
          </div>
        </div>
      </div>

      <div class="container has-text-centered">
        <infinite-loading
          v-if="isFirstPageFinished"
          spinner="waveDots"
          @infinite="infiniteHandler">
          <div slot="no-more"></div>
          <div slot="no-results"></div>
        </infinite-loading>
      </div>

      <b-loading :is-full-page="true" :can-cancel="true" v-model="isLoading"></b-loading>
    </section>

  </div>
</template>

<script>
import { searchByKeyWord } from '@/api/api';

export default {

  metaInfo() {
    return {
      title: this.$t('title.search'),
      meta: [
        { property: 'og:title', vmid: 'og:title', content: this.$t('title.search') },
      ],
    };
  },

  data() {
    return {
      keyWord: '',
      list: [],
      page: 1,
      total: 0,
      lastPage: 0,
      perPage: 12,
      isLoading: false,
      isResultEmpty: false,
      isFirstPageFinished: false,

      hotKeyWords: ['piano', 'marvel', 'starwars', 'disney'],
    };
  },

  created() {

  },

  mounted() {
    this.forGtag();
  },

  beforeDestroy() {
    clearTimeout(this.timer);
  },

  methods: {
    onClickKeyWord(keyWord) {
      this.keyWord = keyWord;
      if (this.keyWord) {
        this.page = 1;
        this.searchKeyWord();
      }
    },

    onSearch() {
      if (this.keyWord) {
        this.page = 1;
        this.searchKeyWord();
        this.$refs.inputSearch = document.activeElement.blur();
      }
    },

    searchKeyWord() {
      this.isLoading = true;
      this.isResultEmpty = false;
      const { keyWord } = this;

      const headers = {
        locale: this.$i18n.locale,
      };

      const params = {
        page: this.page,
      };

      searchByKeyWord(keyWord, { headers, params })
        .then((result) => {
          const searchResult = result.data.data;
          const totalCount = searchResult.nbHits;
          this.total = totalCount > 200 ? 200 : totalCount;
          this.list = searchResult.hits;
          this.perPage = searchResult.hitsPerPage;
          this.lastPage = searchResult.nbPages;

          if (this.total === 0) {
            this.isResultEmpty = true;
          }

          this.isLoading = false;
          this.isFirstPageFinished = true;
        });
    },

    onChangePage(page) {
      if (this.keyWord) {
        this.page = page;
        this.searchKeyWord();
      }
    },

    infiniteHandler($state) {
      if (this.page + 1 > this.lastPage) {
        $state.complete();
        return;
      }

      const { keyWord } = this;

      const headers = {
        locale: this.$i18n.locale,
      };

      const params = {
        page: this.page + 1,
      };

      searchByKeyWord(keyWord, { headers, params })
        .then((result) => {
          const data = result.data.data.hits;

          if (data.length > 0) {
            this.page += 1;
            this.list.push(...data);
            $state.loaded();
          } else {
            $state.complete();
          }
        }).catch((err) => { console.error(err); });
    },

    forGtag() {
      this.timers = setTimeout(() => {
        this.$emit('forGtagStatus', this.$t('title.search'));
      }, 500);
    },
  },
};
</script>

<style scoped>
/deep/ .is-current {
  background-color: rgb(54, 54, 54);
  border-color: rgb(54, 54, 54);
}
</style>
